import { displayTextForAppPlatform } from '@/helpers/displayHelpers';
import { RootState } from '@/reducers/reducers';
import {
    selectDestinationInfoByDestinationStepConfigId,
    selectIsWorkflowsMigratedAndEnabled,
} from '@/selectors/selectors';
import { AppPlatform, AppStoreType } from '@/types';
import React from 'react';
import { useSelector } from 'react-redux';
import Text from 'antd/lib/typography/Text';
import { antGrey } from '../styles/globalStyles';
import _ from 'lodash';

type PlatformsLabelProps = {
    appId: string;
    platform: AppPlatform;
    appStoreType: AppStoreType;
};

export const PlatformsLabel = ({ appId, platform, appStoreType }: PlatformsLabelProps) => {
    const isWorkflowsMigratedAndEnabled = useSelector((state: RootState) =>
        selectIsWorkflowsMigratedAndEnabled(state, appId),
    );

    const destinations = useSelector((state: RootState) =>
        Object.values(selectDestinationInfoByDestinationStepConfigId(state, appId)),
    );

    const shouldHideLabelForOTA = platform === AppPlatform.ReactNativeOTA;

    const displayText = React.useMemo(() => {
        if (!isWorkflowsMigratedAndEnabled || !destinations.length) {
            return shouldHideLabelForOTA ? '' : displayTextForAppPlatform(platform, appStoreType);
        }

        var uniquePlatforms = _.uniq(destinations.map((destination) => destination.platform));
        if (shouldHideLabelForOTA) {
            uniquePlatforms = uniquePlatforms.filter((platform) => platform !== AppPlatform.ReactNativeOTA);
        }
        return uniquePlatforms.map((platform) => displayTextForAppPlatform(platform)).join(' / ');
    }, [isWorkflowsMigratedAndEnabled, destinations, platform, appStoreType]);

    return displayText.length ?
            <Text
                style={{
                    fontSize: destinations.length > 2 ? 16 : 20,
                    color: antGrey.grey6,
                    textAlign: 'right',
                }}
            >
                {displayText}
            </Text>
        :   null;
};
